function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3085 8.75216C24.6014 9.04506 24.6014 9.51993 24.3085 9.81282L18.1213 16L24.8388 22.7175C24.8388 22.7175 24.6014 22.955 24.3085 23.2479L23.2478 24.3085C22.9549 24.6014 22.4801 24.6014 22.1872 24.3085L16 18.1213L9.8128 24.3085C9.5199 24.6014 9.28247 24.8388 9.28247 24.8388L7.69148 23.2479C7.39858 22.955 7.39858 22.4801 7.69148 22.1872L13.8787 16L7.16115 9.2825C7.16115 9.2825 7.39858 9.04506 7.69148 8.75216L8.75214 7.6915C9.04503 7.39861 9.5199 7.39861 9.8128 7.6915L16 13.8787L22.7175 7.16116C22.7175 7.16116 22.9549 7.39861 23.2478 7.6915L24.3085 8.75216Z"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Close.11f494a9.svg";
export { ForwardRef as ReactComponent };